/**
 * Helper functions to generate structured data (JSON-LD) for SEO
 */

/**
 * Generate Organization structured data
 */
export const generateOrganizationSchema = ({
  name = 'Imigo',
  url = 'https://lithoreact.themezaa.com',
  logo = 'https://lithoreact.themezaa.com/assets/pic/logo.png',
  description = 'Imigo is a versatile app designed for immigrants and tourists',
  contactPoint = {
    telephone: '+1-XXX-XXX-XXXX',
    contactType: 'customer service',
    areaServed: 'US',
    availableLanguage: 'English',
  },
  sameAs = [
    // Add your social media profiles here
    // 'https://www.facebook.com/imigo',
    // 'https://www.twitter.com/imigo',
    // 'https://www.instagram.com/imigo',
  ],
}) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name,
    url,
    logo: {
      '@type': 'ImageObject',
      url: logo,
    },
    description,
    contactPoint: {
      '@type': 'ContactPoint',
      ...contactPoint,
    },
    sameAs,
  };
};

/**
 * Generate WebSite structured data
 */
export const generateWebSiteSchema = ({
  name = 'Imigo',
  url = 'https://lithoreact.themezaa.com',
  description = 'Imigo is a versatile app designed for immigrants and tourists',
  potentialAction = {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://lithoreact.themezaa.com/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
}) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name,
    url,
    description,
    potentialAction,
  };
};

/**
 * Generate Article structured data
 */
export const generateArticleSchema = ({
  headline,
  description,
  image,
  datePublished,
  dateModified,
  author = {
    '@type': 'Person',
    name: 'Hani Eisapur',
  },
  publisher = {
    '@type': 'Organization',
    name: 'Imigo',
    logo: {
      '@type': 'ImageObject',
      url: 'https://lithoreact.themezaa.com/assets/pic/logo.png',
    },
  },
  url,
}) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    description,
    image: image ? (Array.isArray(image) ? image : [image]) : undefined,
    datePublished,
    dateModified: dateModified || datePublished,
    author,
    publisher,
    url,
  };
};

/**
 * Generate Event structured data
 */
export const generateEventSchema = ({
  name,
  description,
  startDate,
  endDate,
  location = {
    '@type': 'Place',
    name: 'Location Name',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '',
      addressLocality: '',
      addressRegion: '',
      postalCode: '',
      addressCountry: '',
    },
  },
  image,
  url,
  organizer = {
    '@type': 'Organization',
    name: 'Imigo',
  },
}) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Event',
    name,
    description,
    startDate,
    endDate,
    location,
    image: image ? (Array.isArray(image) ? image : [image]) : undefined,
    url,
    organizer,
  };
};

/**
 * Generate Business structured data
 */
export const generateBusinessSchema = ({
  name,
  description,
  image,
  url,
  address = {
    '@type': 'PostalAddress',
    streetAddress: '',
    addressLocality: '',
    addressRegion: '',
    postalCode: '',
    addressCountry: '',
  },
  telephone,
  priceRange,
  openingHours,
  servesCuisine,
  acceptsReservations,
}) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name,
    description,
    image: image ? (Array.isArray(image) ? image : [image]) : undefined,
    url,
    address,
    telephone,
    priceRange,
    openingHoursSpecification: openingHours
      ? openingHours.map((hours) => ({
          '@type': 'OpeningHoursSpecification',
          ...hours,
        }))
      : undefined,
    servesCuisine,
    acceptsReservations,
  };
};

/**
 * Generate BreadcrumbList structured data
 */
export const generateBreadcrumbSchema = (items) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
};

/**
 * Generate FAQ structured data
 */
export const generateFAQSchema = (faqs) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
};





